import React from 'react';

const HideWhenCampaignActive = ({
  contentId,
  displaysId,
  children,
  currentContentsDisplays,
  editCampaignActive,
  isPaymentStatusApproved
}) => {
  const isContentInCurrentCampaign = () => {
    if (!editCampaignActive) return false;
    if (!isPaymentStatusApproved) return false;
    if (!currentContentsDisplays || currentContentsDisplays.length === 0) return false;

    if (!displaysId) {
      return currentContentsDisplays.some(c => c.contentId === contentId);
    }

    if (Array.isArray(displaysId)) {
      return displaysId.some(displayId =>
        currentContentsDisplays.some(cd => cd.contentId === contentId && cd.displayId === displayId)
      );
    }

    return currentContentsDisplays.some(
      c => c.contentId === contentId && c.displayId === displaysId
    );
  };

  if (isContentInCurrentCampaign()) return null;

  return <>{children}</>;
};

export default HideWhenCampaignActive;
